import React, { useState } from 'react'
import Location from "aws-sdk/clients/location"
import { Auth } from "aws-amplify"
import jwt_decode from "jwt-decode";

export const useCreateAddressScreen = () => {
  const tokenn = localStorage.getItem("token");
  const tokenDecode = jwt_decode(tokenn);

  /* function to get 3 first digits of number */
  const getFirstDigits = (string) => {
    const remainingDigits = string.substring(0, string.length - 10);
    return remainingDigits;
}

  const [directions, setDirections] = useState([]);
  const searchDirection = async (directionText, longitude, latitude) => {

    let BiasPosition;

    if (getFirstDigits(tokenDecode.phoneNumber) == '+57') {
      BiasPosition = [-75.63912, 6.279584]
    } else if (getFirstDigits(tokenDecode.phoneNumber) == '+52') {
      BiasPosition = [-99.13939289199999, 19.27691016700004]
    } else if (getFirstDigits(tokenDecode.phoneNumber) == '+1') {
      BiasPosition = [-74.00713999999994, 40.71455000000003]
    }

    const credentials = await Auth.currentCredentials();
    const client = new Location({
      credentials,
      region: "us-east-1",
    });

    const params = {
      IndexName: "fiado-map",
      Text: directionText,
      BiasPosition: BiasPosition,
      MaxResults: 5,
      FilterCountries: [ "USA", "MEX", 'COL' ],
    };

    client.searchPlaceIndexForText(params, (err, data) => {
      if (err) console.error(err);
      if (data) {
        setDirections(data.Results)
        console.log(data.Results)
      }
    });
  }

  return {
    searchDirection,
    directions
  }
}
